<form [formGroup]="loginForm" (ngSubmit)="loginByEmail()" novalidate>
  <div class="form-group">
    <input
      floAnalytics
      type="email"
      (focus)="email.markAsUntouched()"
      [events]="['click', 'focus']"
      name="Email"
      placeholder="Email Address"
      data-test="email-login"
      autocomplete="off"
      maxlength="76"
      formControlName="email"
      class="form-control-lg"
    />
    <div
      class="spinner-border spinner-border-sm primary-color-text"
      role="status"
      *ngIf="showEmailSpinner$ | async"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
    <flo-form-errors
      *ngIf="showFormErrorComponent()"
      [errors]="email.errors"
      control="loginFormEmail"
      [hasIcon]="true"
    ></flo-form-errors>
    <flo-claim-account-error
      *ngIf="email.hasError('unclaimed_account')"
      [migratedSite]="email.errors?.unclaimed_account?.customText"
      [email]="email.value"
    ></flo-claim-account-error>
  </div>
  <div class="form-group">
    <div class="form-password">
      <input
        floAnalytics
        (focus)="password.markAsUntouched()"
        [events]="['click', 'focus']"
        name="Password"
        formControlName="password"
        placeholder="Password"
        data-test="password"
        autocomplete="off"
        maxlength="126"
        class="form-control-lg"
        [type]="showPassword ? 'text' : 'password'"
      />
      <div class="form-password-icon" (click)="togglePassword($event)">
        <ng-container *ngIf="showPassword; else hidePassword">
          <flo-svg-icon class="show-password-icon" data-test="form-show-password-icon" icon="show-password" height="1.5rem" width="1.5rem"></flo-svg-icon>
        </ng-container>
        <ng-template #hidePassword>
          <flo-svg-icon class="hide-password-icon" data-test="form-hide-password-icon" icon="hide-password" height="1.5rem" width="1.5rem"></flo-svg-icon>
        </ng-template>
      </div>
    </div>
    <flo-form-errors
      *ngIf="password.touched && password.invalid"
      [errors]="password.errors"
      control="loginFormPassword"
      [hasIcon]="true"
    ></flo-form-errors>
  </div>
  <div class="funnel-form-footnotes mb-3">
    <p class="funnel-form-footnote flo-footnote"
      ><a
        routerLink="/forgot-password"
        floAnalytics
        name="Forgot Password"
        class="link-forgot-password text-600 text-decoration-underline hover-grey-900"
        >Forgot Password?</a
      ></p
    >
  </div>
  <div class="form-button">
    <button
      floAnalytics
      events="click"
      name="Login"
      type="submit"
      class="btn btn-primary btn-lg lg-font-btn"
      data-test="login"
      [disabled]="!canSubmitForm"
    >
      Log In
    </button>
    <div
      class="spinner-border spinner-border-sm"
      role="status"
      *ngIf="emailLoginSubmitting"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</form>
